<template>
<modal title="New Product Distribution">
  <form>
    <div class="columns">
      <div class="column">
        <data-selector
          required
          :items="availableDistributions"
          v-model="distribution.distribution_id"
          value-key="id"
          label-key="name">Distribution</data-selector>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <text-input required :error="$root.errors.identifier" v-model="distribution.identifier">Indentifier</text-input>
      </div>
      <div class="column">
        <text-input v-model="distribution.version_retriever">Version Retriever</text-input>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <submit-button class="is-rounded" @submit="saveDistribution">Save</submit-button>
      </div>
    </div>
  </form>
</modal>  
</template>
<script>
import { getPath } from '@/api/common'
import { mapGetters } from 'vuex'
import { differenceBy } from 'lodash'

export default {

  data: () => ({
    distributions: [],
    distribution: {
      distribution_id: '',
      identifier: '',
      version_retriever: ''
    }
  }),

  created() {
    getPath({
      path: 'api/super/distribution-list'
    }, ({data}) => this.distributions = data, error => {})
  },

  methods: {
    saveDistribution() {
      this.$store.dispatch('software/saveDistribution', {
        softwareId: this.software.id,
        ...this.distribution
      }).then(() => {
        this.$toast.success('Saved')
        this.$close(false)
      }).catch(() => {
        this.$toast.error('Whoops')
      })
    }
  },

  computed: {
    ...mapGetters('software', ['software']),
    availableDistributions() {
      return differenceBy(this.distributions, this.software.distributions, 'id')
    }
  }

}
</script>